import { useNavigate } from "react-router-dom";
import { bookTitle, bookSubtitle, bookTagline, bookCoverImage } from "@/mocks/bookData";

export default function BookHero() {
  const navigate = useNavigate();

  const scrollToTOC = () => {
    const el = document.getElementById("toc");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="relative w-full h-[100vh] min-h-[640px] overflow-hidden">
      <img
        src={bookCoverImage}
        alt="Book cover"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-black/40" />

      {/* Back to Home */}
      <div className="absolute top-28 left-6 md:left-10">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 font-['Share_Tech_Mono'] text-[#666] hover:text-[#C8922A] text-xs tracking-[0.2em] uppercase transition-colors duration-300 cursor-pointer"
        >
          <i className="ri-arrow-left-line text-sm" />
          Back to Site
        </button>
      </div>

      {/* Center Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
        <div className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.4em] uppercase mb-6">
          [ A Novel ]
        </div>

        <h1 className="font-['Special_Elite'] text-white text-6xl md:text-8xl lg:text-9xl tracking-tight leading-none mb-4">
          {bookTitle}
        </h1>

        <div className="font-['Special_Elite'] text-[#C8922A]/80 text-xl md:text-2xl tracking-[0.12em] italic mb-8">
          {bookSubtitle}
        </div>

        <div className="w-16 h-px bg-[#C8922A]/40 mb-8" />

        <p className="font-['Rajdhani'] text-[#999] text-base md:text-lg max-w-xl leading-relaxed mb-12">
          {bookTagline}
        </p>

        <button
          onClick={scrollToTOC}
          className="flex items-center gap-3 border border-[#C8922A]/60 hover:border-[#C8922A] hover:bg-[#C8922A]/10 text-[#C8922A] font-['Share_Tech_Mono'] text-xs tracking-[0.25em] uppercase px-8 py-4 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-book-open-line text-sm" />
          Read the Book
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <div className="font-['Share_Tech_Mono'] text-[#333] text-xs tracking-[0.3em] uppercase">
          Scroll
        </div>
        <div className="w-px h-8 bg-gradient-to-b from-[#C8922A]/40 to-transparent" />
      </div>
    </header>
  );
}
